import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
} from './DocumentPage';
import aerialMap from '../../assets/site-layouts/aerial-map.png';
import paintShedLayout from '../../assets/site-layouts/paint-shed-layout.png';
import refurbishmentShedLayout from '../../assets/site-layouts/refurbishment-shed-layout.png';

const LAYOUTS = [
  {
    id: 'aerial',
    title: 'Aerial Map',
    description:
      'Site aerial overview showing the Pressure Vessel Services Limited yard and building footprint.',
    src: aerialMap,
    alt: 'Aerial map of the PVS site',
  },
  {
    id: 'paint',
    title: 'Paint Shed Layout',
    description:
      'Internal layout of the paint shed, including work areas and associated facilities.',
    src: paintShedLayout,
    alt: 'Paint shed layout plan',
  },
  {
    id: 'refurb',
    title: 'Refurbishment Shed Layout',
    description:
      'Internal layout of the refurbishment shed, including work areas and associated facilities.',
    src: refurbishmentShedLayout,
    alt: 'Refurbishment shed layout plan',
  },
];

const SiteLayoutsDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Site Layouts"
    documentHeading="PVS Site Layout Plans"
    includeDefaultMeta={false}
    meta={[
      ['Company', 'Pressure Vessel Services Limited'],
      ['Document Title', 'PVS Site Layout Plans'],
      ['Document Reference', 'PVS-DOC-SL-001'],
      ['Version', '1.0'],
      ['Date of Issue', '17th July 2026'],
      ['Next Review Date', '17th July 2027'],
      ['Review Period', '12 months'],
      ['Prepared by', 'Pressure Vessel Services Limited'],
      ['Approved by', 'Board of Directors'],
      ['Applicability', 'All PVS personnel, subcontractors and authorised visitors on PVS premises'],
    ]}
    acknowledgment={{
      documentName: 'PVS Site Layout Plans',
      documentReference: 'PVS-DOC-SL-001',
      processActivity: 'Site Orientation & Layout Familiarisation',
      versionNumber: '1.0',
      dateOfIssue: '17th July 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Purpose and Scope">
      <Paragraph>
        This document provides the controlled site layout drawings for Pressure Vessel Services
        Limited (PVS). It is issued to support site orientation, emergency response familiarity,
        and day-to-day awareness of yard and shed arrangements.
      </Paragraph>
      <Paragraph className="mt-2">
        The drawings cover the site aerial overview, the paint shed layout, and the
        refurbishment shed layout. Personnel must familiarise themselves with these layouts
        before working unsupervised on PVS premises.
      </Paragraph>
    </Section>

    <Section number="2" title="Layout Drawings">
      <div className="space-y-10">
        {LAYOUTS.map((layout, index) => (
          <div key={layout.id}>
            <h4 className="text-xl font-semibold mb-2 text-pvs-accent">
              2.{index + 1} {layout.title}
            </h4>
            <Paragraph className="mb-4">{layout.description}</Paragraph>
            <div className="rounded-lg border border-pvs-border overflow-hidden bg-black/20">
              <img
                src={layout.src}
                alt={layout.alt}
                className="w-full h-auto block"
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </Section>

    <Section number="3" title="Document Control">
      <Paragraph>
        These drawings are controlled documents. Superseded versions must not be retained for
        operational use. Any proposed changes to yard or shed layouts shall be reflected in a
        revised issue of this document following approval by the Board of Directors.
      </Paragraph>
      <p className="text-center text-pvs-text-muted mt-8 text-sm">
        <em>END OF DOCUMENT — PVS-DOC-SL-001 Rev 1.0</em>
      </p>
    </Section>
  </DocumentPage>
);

export default SiteLayoutsDoc;
